<template>
    <div class="field custom-number-input">
        <label :for="id" v-if="label" class="label">{{ label }}</label>
        <div class="control is-gapless is-vcentered">
            <b-numberinput
                :name="id"
                :value="validValue"
                :min="minimumValue"
                :max="maximumValue"
                :step="stepSize"
                :controls="false"
                @input="$emit('input', parseInt($event))"
            />

            <div class="control-flex-container">
                <div class="custom-number-input__controls">
                    <a
                        @click="decreaseValue()"
                        :class="{ loading: isDecreaseLoading }"
                        class="control__decrease"
                        >-</a
                    >
                    <a
                        @click="increaseValue()"
                        :class="{ loading: isIncreaseLoading }"
                        class="control__increase"
                        >+</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NumberInput',
    data() {
        return {
            isDecreaseLoading: false,
            isIncreaseLoading: false,
        };
    },
    props: {
        label: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: false,
        },
        value: {
            type: Number,
            required: false,
            default: 1,
        },
        minimumValue: {
            type: Number,
            required: false,
            default: null,
        },
        maximumValue: {
            type: Number,
            required: false,
            default: null,
        },
        stepSize: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    computed: {
        validValue() {
            let validValue = this.value;

            if (this.maximumValue && this.minimumValue) {
                validValue = Math.max(
                    this.minimumValue,
                    Math.min(this.maximumValue, this.value)
                );
            } else if (this.maximumValue) {
                validValue = Math.min(this.maximumValue, this.value);
            } else if (this.minimumValue) {
                validValue = Math.max(this.minimumValue, this.value);
            }

            if (validValue !== this.value) {
                this.$emit('input', validValue);
            }
            return validValue;
        },
        isIncreaseAllowed() {
            if (this.maximumValue) {
                return this.validValue + this.stepSize <= this.maximumValue;
            } else {
                return true;
            }
        },
        isDecreaseAllowed() {
            if (this.minimumValue) {
                return this.validValue - this.stepSize >= this.minimumValue;
            } else {
                return true;
            }
        },
    },
    methods: {
        increaseValue() {
            this.isIncreaseLoading = true;
            if (this.isIncreaseAllowed) {
                this.$emit(
                    'input',
                    Math.round(this.validValue + this.stepSize)
                );
            }
            setTimeout(() => {
                this.isIncreaseLoading = false;
            }, 100);
        },
        decreaseValue() {
            this.isDecreaseLoading = true;
            if (this.isDecreaseAllowed) {
                this.$emit('input', this.validValue - this.stepSize);
            }
            setTimeout(() => {
                this.isDecreaseLoading = false;
            }, 100);
        },
    },
};
</script>

<style lang="scss">
.custom-number-input {
    &__input {
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        &[type='number'] {
            -webkit-appearance: none;
            -moz-appearance: textfield;
        }
    }

    &__controls {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        a {
            transition: background-color 50ms ease-in-out;

            &.loading {
                background-color: $primary-lightest;
            }
        }
    }
}
</style>
